import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Table from "../../../common/table/Table.component";
import HandlingResponse from "../../../common/handling-response/handlingResponse";
import SettingsClient from "../../api-services/settings/settings-client";
import SideModal from "../../../common/modal/SideModal.component";
import EditSettings from "../../components/edit-settings/EditSettings.component";
import { SettingsModel, JSONFilesList } from "../../models/Settings";
import JsonClient from "../../api-services/json/json-client";
import Select from "../../../common/custom-select-list/CustomSelectList.component";

const Settings = () => {
  const tableName = "REG_SETTINGS";

  const columns = [
    {
      Header: "Id",
      accessor: "id",
    },
    {
      Header: "Назив",
      accessor: "parameterKey",
    },
    {
      Header: "Вредност",
      accessor: "parameterValue",
    },
    {
      Header: "Опис",
      accessor: "description",
    },
    {
      accessor: "edit",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <button
            title="Измена"
            className="btn btn-primary table-btn"
            onClick={() => getParamsForEdit(row.original)}
            type="button"
          >
            <FontAwesomeIcon icon={solid("edit")} />
          </button>
        );
      },
    },
  ];

  const client = new SettingsClient();
  const jsonClient = new JsonClient();

  const [settingsList, setSettingsList] = useState([]);
  const [show, setShow] = useState(false);
  const [settingsParams, setSettingsParams] = useState(new SettingsModel());
  const [jsonParameter, setJsonParameter] = useState(0);

  useEffect(() => {
    getAll();
  }, []);

  const showModal = () => setShow(true);
  const hideModal = () => setShow(false);

  const getAll = async () => {
    let response = await client.getAll();
    let handledResponse = HandlingResponse(response);
    handledResponse && setSettingsList(handledResponse);
  };

  const getParamsForEdit = async (data) => {
    setSettingsParams(data);
    showModal();
  };

  const handleAddingDataToTable = (childData) => {
    hideModal();
    let settingsListCopy = [...settingsList];
    let index = settingsListCopy.findIndex((x) => x.id === childData.id);
    settingsListCopy[index] = childData;
    setSettingsList(settingsListCopy);
  };

  const createJSONFile = async () => {
    let response = await jsonClient.createJSONFile(jsonParameter);
    let handledResponse = HandlingResponse(response);
  };

  return (
    <>
      <div className="row">
        <div>
          <h5>Генерисање JSON фајлова</h5>
        </div>
        <div className="col-4">
          <Select
            id="json-files"
            options={JSONFilesList}
            onChange={(event) => setJsonParameter(event.value)}
            value={JSONFilesList.filter((x) => x.value === jsonParameter)}
          />
        </div>
        <div className="col-2">
        <button
          className="btn btn-primary"
          type="button"
          onClick={() => createJSONFile()}
        >
          Генериши JSON фајлове
        </button>
        </div>
      </div>
      <hr />
      <div>
        {settingsList.length > 0 && (
          <Table
            columns={columns}
            data={settingsList}
            rememberFilter={true}
            tableName={tableName}
            hiddenColumn={["id"]}
            serverSide={false}
          />
        )}
      </div>
      <SideModal
        show={show}
        handleClose={hideModal}
        title={"Измена параметара"}
      >
        <EditSettings
          data={settingsParams}
          handleCallback={handleAddingDataToTable}
        />
      </SideModal>
    </>
  );
};

export default Settings;
